import { Button, Col, Modal, Row, Space, Typography, message } from "antd";
import DataLogsView from "../components/DataLogsView";
import { SearchQuery } from "../code/search-query/search-query";
import { useState } from "react";
import { Guid } from "guid-typescript";
import Loader from "../controls/Loader";
import { getDataLogsExport } from "../repository/data.repository";
import { getProblemMessage } from "../utils/http";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

function DataLogsPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const permissions = useSelector(authorizeSelectors.permissions);

  // Events

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading Data Logs export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getDataLogsExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          {/* PD-01 §21 — this grid is the entity-lifecycle audit log
              (create / update / delete / anonymize), surfaced via the
              AppAudits endpoint. The compliance audit refers to it as
              "Lifecycle Logs"; keep the technical name but add that alias
              in parentheses so operators can find it by either label. */}
          Data Logs <Typography.Text type="secondary">(Lifecycle Logs)</Typography.Text>
        </Typography.Title>
        <Space className="flex flex-row">
          <Button
            type="primary"
            disabled={!permissions.can("AppAudits", "view")}
            onClick={() => onDownloadExport()}
          >
            Export to Excel
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <DataLogsView trigger={triggerView} onSearch={onSearch} />
      </Col>
      {contextHolder}
    </Col>
  );
}

export default DataLogsPage;
